export const DESKTOP_MEDIA_QUERY = '1620px';
